<template>
  <div class="popup-wrapper sifrarnik">
    <DataLoader :is_on="updating" />
    <div class="radnje-content">
      <div class="sifrarnik-radnje-title"><span>Dodaj radnju</span>
        <a @click="closePopup()" class="popup-close-icon-wrapper"><img src="@/assets/img/entry_form_close.svg" /></a>
      </div>
      <div class="radnje-main-wrapper">
        <div class="main-sub-wrapper" v-for="(tbr,key) in radnje" :key="key">
          <div @click="showSubtree" class="radnja-tbr-main-wrapper">
              <div class="main-tbr">
                  <div class="number-name-wrapper">
                      <div class="tbr-number">{{tbr.number != null ? tbr.number : ''}}</div>
                      <div class="tbr-name">{{tbr.name != null ? tbr.name : ''}}</div>
                  </div>
                  <div class="tbr-more-svg"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="14" height="9" version="1.1" viewBox="0 0 14 9"><defs/><desc>Generated with Avocode.</desc><g><g><title>Vector</title><path d="M0.99946,0.99986v0l6.00028,6.00014v0l6.00016,-6.00014v0" fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#3326ae" stroke-miterlimit="20" stroke-width="2.0000000000000018"/></g></g></svg></div>
              </div>
          </div>
          <div class="sub-tbr">
              <div class="number-name-wrapper" v-for="(sub_tbr,ky) in tbr.other_sifarnik" :key="ky">
                  <div class="tbr-number">{{sub_tbr.number}}</div>
                  <div class="tbr-name">{{sub_tbr.name.split('.')[2].slice(1)}}</div>
                  <div class="tbr-points">{{sub_tbr.value != null && sub_tbr.value > 0 ? sub_tbr.value : '?'}}</div>
                  <div :key="refreshKey" class="task-checkbox-container">
                      <!-- spinner koji se aktivira na klik i traje dok se ne izvrsi update -->
                      <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                      </svg>

                      <div :class="['task-checkbox', 'popup-check', sub_tbr.active ? 'active' : '']" @click="addToListTemp(sub_tbr)">
                          <div class="check"></div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="add-radnja" @click="closePopup()">
      Dodaj radnju
    </div>
    <!-- get 4.1 bodovi -->
    <v-dialog v-model="bodovi_41_dialog" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Odaberite stavku tarifnog broja 4.1.
        </div>
        <div>
          <div :style="radnja_41.chosen_stavka == 1 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 1">kaznena djela za koja je predviđena novčana kazna ili kazna do 3 godine zatvora: 100 bodova</div>
          <div :style="radnja_41.chosen_stavka == 2 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 2">kaznena djela za koja je predviđena kazna do 5 godina zatvora: 200 bodova </div>
          <div :style="radnja_41.chosen_stavka == 3 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 3">kaznena djela za koja je predviđena kazna do 10 godina zatvora: 300 bodova </div>
          <div :style="radnja_41.chosen_stavka == 4 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 4">kaznena djela za koja je predviđena kazna preko 10 godina zatvora: 400 bodova </div>
          <div :style="radnja_41.chosen_stavka == 5 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 5">obranu pred sucem za prekršaje: 50 bodova</div>
          <div :style="radnja_41.chosen_stavka == 6 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 6">obranu pred sucem za prekršaje ako se uz izricanje novčane kazne <input v-model="radnja_41.oduzimanje_predmeta_input" type="text"/> bodova</div>
          <div :style="radnja_41.chosen_stavka == 7 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 7">obrana pravne osobe <input v-model="radnja_41.visina_kazne" type="text"/> bodova</div>
          <div :style="radnja_41.chosen_stavka == 8 ? 'text-decoration: underline;' : '' " @click="radnja_41.chosen_stavka = 8">ostalo <input v-model="radnja_41.ostalo_input" type="text"/> bodova</div>
          <div >dodatni sati: <input type="number" v-model="radnja_41.dodatni_sati_41"></div>
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="bodovi_41_dialog = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveSelection41()"> Spremi </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dodatni_sati_dialog" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Odaberite broj sati
        </div>
        <div>
          <div >Broj sati: <input type="number" v-model="dodatni_sati"></div>
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="dodatni_sati_dialog = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveDodatni()"> Spremi </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="custom_dialog" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Nije moguće automatski izračunati vrijednost ove stavke. Molimo da na temelju opisa načina izračuna ručno izračunate broj bodova ove stavke!
        </div>
        <div class="tbr-description">
          <div class="description-text">{{this.chosen_element!=null ? this.chosen_element.description : ''}}</div>
          <!-- <div > <input type="number" v-model="custom_bodovi"></div> -->
          <v-text-field
            label="Broj bodova"
            hint="1 bod = 2 EUR"
            v-model="custom_bodovi"
            regular
            type="number"
          />
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="custom_dialog = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveCustom()"> Spremi </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bodovi_71_dialog" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Tarifna stavka 7.1
        </div>
        <div class="tbr71-osnovica">Osnovica: <input type="number" v-model="tbr71_osnovica"></div>
        <div class="tbr71-content">
          <div :class="'tbr71-row'"><span class="tbr71_w1">OD</span><span class="tbr71_w2">DO</span><span class="tbr71_w3">BODOVA</span></div>
          <div :class="['tbr71-row',tbr71_osnovica >= 2500.01 && tbr71_osnovica < 5000.01 ? 'active' : '']"><span class="tbr71_w1">2.500,01</span><span class="tbr71_w2">5.000,00</span><span class="tbr71_w3">50</span></div>
          <div :class="['tbr71-row',tbr71_osnovica >= 5000.01 && tbr71_osnovica < 10000.01 ? 'active' : '']"><span class="tbr71_w1">5.000,01</span><span class="tbr71_w2">10.000,00</span><span class="tbr71_w3">75</span></div>
          <div :class="['tbr71-row',tbr71_osnovica >= 10000.01 && tbr71_osnovica < 100000.01 ? 'active' : '']"><span class="tbr71_w1">10.000,01</span><span class="tbr71_w2">100.000,00</span><span class="tbr71_w3">100</span></div>
          <div :class="['tbr71-row',tbr71_osnovica >= 100000.01 && tbr71_osnovica < 250000.01 ? 'active' : '']"><span class="tbr71_w1">100.000,01</span><span class="tbr71_w2">250.000,00</span><span class="tbr71_w3">250</span></div>
          <div :class="['tbr71-row',tbr71_osnovica >= 250000.01 && tbr71_osnovica < 500000.01 ? 'active' : '']"><span class="tbr71_w1">250.000,01</span><span class="tbr71_w2">500.000,00</span><span class="tbr71_w3">500</span></div>
          <div :class="['tbr71-row',tbr71_osnovica >= 500000.01 ? 'active' : '']"><span class="tbr71_w1">500.000,01</span><span class="tbr71_w2">> 500.000,00</span><input class="tbr71_w3" type="number" v-model="radnja_71_custom_bodovi"></div>
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="bodovi_71_dialog = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveSelection71()"> Spremi </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
  <!-- end popup wrapper -->
</template>

<script>
import $ from "jquery";
import gsap from "gsap";
import DataLoader from '@/components/generalComponents/DataLoader'

export default {
  props: ['radnje', "chosen_row"],
  data() {
    return {
      accessToken: "",
      updating:false,
      refreshKey:0,
      listToReturn:[],
      bodovi_41_dialog:false,
      radnja_41:{
        oduzimanje_predmeta_input:0,
        visina_kazne:0,
        ostalo_input:0,
        dodatni_sati_41:0,
        chosen_stavka:null,
      },
      dodatni_sati:0,
      chosen_element:null,
      dodatni_sati_dialog:false,
      custom_dialog:false,
      bodovi_71_dialog:false,
      custom_bodovi:0,
      radnja_71_custom_bodovi:0,
      tbr71_osnovica:'',
    }
  },
  components: {
    DataLoader,
  },
  methods: {
    closePopup() {
        this.$emit('closePopup');
        this.radnje.forEach(tb=>tb.other_sifarnik.map(st=>{st.active =false}))
    },
    setInitVals(){
      this.chosen_row.iznos = 0;
      this.dodatni_sati = 0;
      this.custom_bodovi = 0;
      this.radnja_41={
        oduzimanje_predmeta_input:0,
        visina_kazne:0,
        ostalo_input:0,
        dodatni_sati_41:0,
        chosen_stavka:null,
      };
    },
    addToListTemp(sub){
      this.setInitVals();
      this.radnje.forEach(tb=>tb.other_sifarnik.map(st=>{st.active =false}))
      this.chosen_element = sub;
      if (sub.value > 0) {
        this.chosen_row.iznos = this.chosen_element.value*2;
        this.continueCalculation();
      }
      else{
        this.custom_dialog = true;
      }
    },
    addToList(sub){
      this.setInitVals();
      this.radnje.forEach(tb=>tb.stavke_tarife.map(st=>{st.active =false}))
      this.chosen_element = sub;
      //provjeri custom trosak
      //provjeri ovisnost o tbr71
      if(sub.ovisi_o_tbr41){
        this.bodovi_41_dialog=true;
      }
      else if(sub.ovisi_o_tbr71){
        this.tbr71_osnovica = sub.tbr71_osnovica_vps == true ? this.$store.state.currency_data.input_value : 0;
        this.bodovi_71_dialog=true;
      }
      else{
        if (sub.broj_bodova != null) {
          this.chosen_row.iznos = sub.broj_bodova*2;
        }
        if (sub.dodatni_bodovi != null) {
          this.dodatni_sati_dialog = true;
        }
        if (sub.ima_custom_trosak) {
          this.custom_dialog = true;
        }
        else{
          this.continueCalculation();
        }
      }
    },
    saveCustom(){
      this.chosen_row.iznos += this.custom_bodovi*2;
      this.custom_dialog = false;
      this.continueCalculation();
    },
    saveDodatni(){
      this.chosen_row.iznos += this.dodatni_sati*this.chosen_element.dodatni_bodovi*2;
      this.dodatni_sati_dialog = false;
      this.continueCalculation();
    },
    saveSelection41(){
      switch (this.radnja_41.chosen_stavka) {
        case 1:
          this.chosen_row.iznos += 100*2
          break;
        case 2:
          this.chosen_row.iznos += 200*2
          break;
        case 3:
          this.chosen_row.iznos += 300*2
          break;
        case 4:
          this.chosen_row.iznos += 400*2
          break;
        case 5:
          this.chosen_row.iznos += 50*2
          break;
        case 6:
          this.chosen_row.iznos += this.radnja_41.oduzimanje_predmeta_input*2
          break;
        case 7:
          this.chosen_row.iznos += this.radnja_41.visina_kazne*2
          break;
        case 8:
          this.chosen_row.iznos += this.radnja_41.ostalo_input*2
          break;
        default:
          break;
      }
      this.chosen_row.iznos += this.radnja_41.dodatni_sati_41*50*2;
      this.bodovi_41_dialog=false;
      this.continueCalculation();
    },
    saveSelection71(){
      let temp_points = 0;
      if (this.tbr71_osnovica >= 2500.01 && this.tbr71_osnovica < 5000.01 ) {
        temp_points = 50;
      }
      else if (this.tbr71_osnovica >= 5000.01 && this.tbr71_osnovica < 10000.01 ) {
        temp_points = 75;
      }
      else if (this.tbr71_osnovica >= 10000.01 && this.tbr71_osnovica < 100000.01 ) {
        temp_points = 100;
      }
      else if (this.tbr71_osnovica >= 100000.01 && this.tbr71_osnovica < 250000.01 ) {
        temp_points = 250;
      }
      else if (this.tbr71_osnovica >= 250000.01 && this.tbr71_osnovica < 500000.01 ) {
        temp_points = 500;
      }
      else if (this.tbr71_osnovica >= 500000.01) {
        temp_points = this.radnja_71_custom_bodovi;
      }
      if (temp_points != 0) {
        this.chosen_row.iznos += parseInt(temp_points)*2;
        this.bodovi_71_dialog=false;
        this.continueCalculation();
      }

    },
    continueCalculation(){
      // if (this.chosen_element.modifikacija_vrijednosti != null) {
      //   this.chosen_row.iznos*=this.chosen_element.modifikacija_vrijednosti/100;
      // }
      this.chosen_element.active = !this.chosen_element.active;
      this.chosen_row.tbrovi = "Tbr."+this.chosen_element.number;
      this.chosen_row.opis = this.chosen_element.name.split('.')[2].slice(1);
      this.refreshKey++;
    },
    showSubtree(e){
      $(e.target).closest('.radnja-tbr-main-wrapper').next('.sub-tbr').toggleClass('act');
    }
  },
  created() {
  },
  mounted() {
    //close anim
    gsap.to(".mainH", 0.5, { overflow: "hidden" });
    gsap.to(".entry-troskovnik", 0.5, {
      filter: "blur(5px)",
      opacity: 0.2,
      pointerEvents: "none"
    });
    gsap.fromTo(
      ".popup-wrapper",
      0.5,
      { opacity: 0 },
      { zIndex: "999", opacity: 1 }
    );
    $(".popup-close-icon-wrapper").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  destroyed() {
    $(".popup-close-icon-wrapper").off();
  },
};
</script>

<style>
</style>